
import { JsonObject, JsonProperty } from 'json2typescript';
import { Lawyer, LawyerLite } from '../lawyers/lawyer';

@JsonObject('LawyerSession')
export class LawyerSession {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('lawyer', LawyerLite, true)
    lawyer: LawyerLite = null;

    // write data
    @JsonProperty('lawyer_id', Number, true)
    lawyerId: number = undefined;
}